
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  openCard,
  checkCardInfo,
  getImgCode
} from "@/api/api-operation-service";
import { getCountryCodeList } from "@/api/api-basic";
import regular from "@/common/regular";
import validate from "@/common/regular";
import i18n from "@/config/i18n";
import operationCard from "@/components/operation-card/operation-card.vue";

@Component({
  components: {
    "operation-card": operationCard
  }
})
export default class PiNonRealAddCard extends Vue {
  private FormData: objAny = {};

  private ruleInline = {
    cardPhysicalNumber: [
      {
        required: true,
        validator: validate.abcNumber,
        trigger: "change",
        name: i18n.t("nonRealNameCardManagement.cardPhysicalNumber"),
        min: 1,
        max: 20
      }
    ],
    silkScreenNumber: [
      {
        required: true,
        name: i18n.t("nonRealNameCardManagement.silkScreenNumber"),
        trigger: "change",
        validator: validate.abcNumber,
        min: 1,
        max: 20
      }
    ],
    contactName: [
      {
        required: true,
        message: i18n.t("regular.please"),
        trigger: "change"
      }
    ],
    identityCardNumber: [
      {
        required: true,
        message: i18n.t("regular.please"),
        trigger: "change"
      }
    ],
    email: [
      {
        required: true,
        validator: regular.emailRegular,
        trigger: "change"
      }
    ],
    times: [
      {
        required: true,
        type: "array",
        message: i18n.t("formText.selectTimePl"),
        trigger: "change"
      }
    ],
    chargingTime: [
      {
        required: true,
        name: i18n.t("nonCard.chargingHours"),
        trigger: "change",
        max: 24,
        min: 0.01,
        validator: regular.money
      }
    ],
    phoneNo: [
      {
        required: false,
        name: i18n.t("nonRealNameCardManagement.phone"),
        validator: (rule: any, value: string, callback: any) => {
          console.log(rule);
          const reg = /^[0-9]{6,15}$/;
          if (!this.formInline.countryCode && !value) {
            callback();
          } else if (value === "") {
            callback(new Error(i18n.t("regular.phonePl") + ""));
          } else if (!reg.test(value)) {
            callback(new Error(i18n.t("regular.phoneError") + ""));
          } else {
            callback();
          }
        },
        trigger: "blur"
      }
    ],
    imgCode: [
      {
        required: true,
        name: i18n.t("nonCard.verCode"),
        validator: validate.abcNumber,
        trigger: "change",
        min: 5,
        max: 5
      }
    ]
  };

  private formInline: objAny = {
    cardPhysicalNumber: "",
    contactName: "",
    memberType: "0",
    phoneNo: "",
    silkScreenNumber: "",
    times: [],
    effectiveBeginTime: "",
    effectiveEndTime: "",
    imgCode: "",
    email: ""
  };

  /**
   * 刷卡文字
   */
  public handAddSubmit(saveType: number): void {
    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.validEmail(saveType);
      }
    });
  }

  async validEmail(saveType: number): Promise<void> {
    const res = await checkCardInfo({ email: this.formInline.email });
    if (res?.data?.length) {
      const { registerFlag, bindFlag } = res.data[0];

      if (bindFlag) {
        this.$Modal.error({
          title: i18n.t("saveFailed") + "",
          content: i18n.t("emailBandTips") + "",
          okText: i18n.t("confirm") + "",
          onOk: async () => {}
        });
        return;
      }

      if (!registerFlag) {
        this.$Modal.confirm({
          title: i18n.t("confirm") + "",
          content: i18n.t("emailNoRegTips") + "",
          okText: i18n.t("confirm") + "",
          onOk: async () => {
            this.addCard(saveType);
          }
        });
        return;
      }

      this.addCard(saveType);
    }
  }
  private timeChange(value: string[]): void {
    this.formInline.effectiveBeginTime = value[0];
    this.formInline.effectiveEndTime = value[1];
  }
  private openLoading = false;
  async addCard(saveType: number): Promise<void> {
    this.openLoading = true;
    const data = { ...this.formInline, saveType, accountType: 2 };
    delete data.times;
    const ret = await openCard(data);
    this.openLoading = false;
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(
        i18n.t("nonRealNameCardManagement.openCardSuccess")
      );
      this["$common"].goBack(
        this.$route,
        "/oper-manage/non-real-name-card-management"
      );
    }
  }

  // 获取电话区号
  public codeList: any = [];
  async getCodeList() {
    const res = await getCountryCodeList();
    if (res.status === this.$config.apiStatus) {
      this.codeList = res.data || [];
    }
  }
  private imgCode = ""; // 图片验证码
  async getVerCode() {
    const res = await getImgCode();
    if (res.status === this.$config.apiStatus && res.data?.length) {
      this.imgCode = "data:image/png;base64," + res.data[0];
    }
  }
  mounted(): void {
    this.getCodeList();
    this.getVerCode();
    this.$nextTick(() => {
      this.formInline.memberType = this.$route.query.memberType;
      this.FormData = this.$refs.formInline || {};
    });
  }
}
